var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-medium-size-100 md-size-66"},[_c('edit-profile-form',{attrs:{"data-background-color":"green"}})],1),_c('div',{staticClass:"md-layout-item md-medium-size-100 md-size-33"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }